import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";

function BalanceCheckerEditorHelpButton() {
  // States
  const [open, setOpen] = useState(false);

  // Functions
  const handleClose = () => {
    setOpen(false);
  };

  // Render
  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>How to use the editor</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            The previews are contained within div tags, this means that
            selectors like body or html won&apos;t work, and global styles like
            fonts applied to those selectors won&apos;t be visible. Global
            selectors won&apos;t affect the preview, but they will take effect
            when the CSS file is uploaded on our system. We recommend using
            specific selectors to avoid unexpected behaviour.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button type="text" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Tooltip title="Help">
        <IconButton onClick={() => setOpen(true)}>
          <HelpOutlineRoundedIcon />
        </IconButton>
      </Tooltip>
    </>
  );
}

export default BalanceCheckerEditorHelpButton;
